__turbopack_context__.v({
  "className": "anton_7fd6c1db-module__yk3l0W__className",
});
